import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { EnabledAppToolsForSessionAtom } from '../../tools/atoms/appToolsAtom';
import { BuildInAppToolId } from '../../tools/types/appTools';

export const useEnabledAppTools = (tool: BuildInAppToolId, isEnabled: boolean) => {
    const [tools, setEnabledSessionTool] = useAtom(EnabledAppToolsForSessionAtom);

    useEffect(() => {
        // The reason we need to the following condition
        // is because as soon as this app is enabled, the
        // we don't want to run setEnabledSessionTool again
        // because it will cause a re-run of the useEffect
        // in useDefaultAppTool hook and will not allow
        // the user to change the active app tool
        const toolIsEnabled = tools[tool];
        if (!toolIsEnabled) {
            setEnabledSessionTool(prev => ({ ...prev, [tool]: isEnabled }));
        }
    }, [isEnabled]);
};
